import { Menu } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ActionShortcutHint } from 'app/modules/wallforming/components/input-binding/ActionShortcutHint';
import { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const SelectAll = () => {
    const { t } = useTranslation();

    const { selectAllArticleInstances, articles } = usePlacementStore(
        useShallow((state) => ({
            selectAllArticleInstances: state.selectAllArticleInstances,
            articles: state.articles
        }))
    );

    const anyObjectsPlaced = Object.values(articles).some(
        (article) => Object.keys(article.articleInstances).length > 0
    );

    return (
        <Menu.Item
            disabled={!anyObjectsPlaced}
            leftSection={
                <Icon className="action-menu-entry-decoration action-menu-entry-decoration-icon" icon="select_all" />
            }
            rightSection={
                <ActionShortcutHint actionId={InputActionId.ArticleSelectAll} />
            }
            onClick={() => selectAllArticleInstances()}
        >
            {t('selectAll')}
        </Menu.Item>
    );
};
